module.exports = __webpack_public_path__ + "static/img/main-title4.db0e283.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/researchSystem/images/main-title4.png
// module id = YG8i
// module chunks = 0